import { render, staticRenderFns } from "./LoggedInWrapper.vue?vue&type=template&id=5f875991"
import script from "./LoggedInWrapper.vue?vue&type=script&lang=ts"
export * from "./LoggedInWrapper.vue?vue&type=script&lang=ts"
import style0 from "./LoggedInWrapper.vue?vue&type=style&index=0&id=5f875991&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports